<div class="file-reference-cell">
  <span class="file-label" *ngIf="label">{{ label }}</span>
  <span class="file-path" [class.empty]="!filePath" [title]="filePath">{{ getDisplayPath() }}</span>
  <button mat-icon-button
          class="clear-btn"
          *ngIf="filePath && !isEditMode"
          (click)="clearFile()"
          matTooltip="Clear file">
    <mat-icon>close</mat-icon>
  </button>
  <button mat-icon-button
          class="browse-btn"
          (click)="openFileBrowser()"
          [disabled]="isEditMode"
          matTooltip="Browse files">
    <mat-icon>more_horiz</mat-icon>
  </button>
</div>
